/**
 * 返回当前环境的一个集合，这是一个糖
 */
import ApiMap from './ApiMap.js'
import runType from './RunType.js'

export default ApiMap[runType]
